import { styled } from '@mui/material/styles';
import { ReactComponent as Icon } from '@/assets/audio.svg';
import classNames from 'classnames';

export const AudioIcon = styled(
	({ className }: { className?: string }) => (
		<Icon className={classNames('icon', 'audio', className)} />
	),
	{
		target: 'AudioIcon-root',
		label: 'AudioIcon',
	},
)({
	'& .st0': {
		fill: 'none',
		strokeLinejoin: 'round',
		strokeWidth: 0.9,
	},
});
